var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.title,
        centered: "",
        maskClosable: false,
        visible: _vm.popConfig.show,
        closable: true,
        footer: null,
        width: 1000,
      },
      on: { cancel: _vm.closeModal },
    },
    [_vm.popConfig.show ? _vm._t("default") : _vm._e()],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }